import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconThumbsDown_16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <g transform="rotate(180 8 8)">
        <path
          d="M4.66665 14.6668H2.66665C2.31302 14.6668 1.97389 14.5264 1.72384 14.2763C1.47379 14.0263 1.33331 13.6871 1.33331 13.3335L1.33331 8.66683C1.33331 8.31321 1.47379 7.97407 1.72384 7.72402C1.97389 7.47397 2.31302 7.3335 2.66665 7.3335H4.66665M9.33331 6.00016V3.3335C9.33331 2.80306 9.1226 2.29436 8.74753 1.91928C8.37245 1.54421 7.86375 1.3335 7.33331 1.3335L4.66665 7.3335L4.66665 14.6668L12.1866 14.6668C12.5082 14.6705 12.8202 14.5578 13.0653 14.3495C13.3103 14.1412 13.4718 13.8514 13.52 13.5335L14.44 7.5335C14.469 7.3424 14.4561 7.14728 14.4022 6.96166C14.3483 6.77604 14.2547 6.60436 14.1279 6.45851C14.0011 6.31265 13.844 6.19612 13.6677 6.11697C13.4914 6.03783 13.2999 5.99797 13.1066 6.00016L9.33331 6.00016Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
});
IconThumbsDown_16.displayName = 'IconThumbsDown_16';
